import axios from '@/request';
import { ResponseAPIType, USER_LINK_PRODUCT } from '@ecoflow/ef-device-core/src/constants';
import { ResponseGetUserLinkProductType } from '@ecoflow/ef-device-core/src/types';

// 获取用户产品关联设置
export async function getUserLinkProduct(): Promise<ResponseAPIType<ResponseGetUserLinkProductType>> {
    const response = await axios.get({
        url: '/usercenter/user/preferences/detail',
        params: {
            propertyName: USER_LINK_PRODUCT,
        },
    });

    return response.data;
}
